module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Verbindung 1 ro.f5d4a983.svg";